import React from 'react';
import { ColorId } from 'referral-types';
import chroma from 'chroma-js';
import { GridSubthemeProps, useGridSubthemeColors } from './gridSubthemeShared';

const SimpleGridBackground: React.FC<GridSubthemeProps> = (props) => {
  const resolvedColors = useGridSubthemeColors(props.themeRevision, {
    colorId1: ColorId.Gray1,
    colorId2: ColorId.Gray5,
  });

  const lineColor = chroma(resolvedColors.color2).alpha(0.3).css();

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        backgroundColor: resolvedColors.color1,
        backgroundImage: `
          linear-gradient(to right, ${lineColor} 1px, transparent 1px),
          linear-gradient(to bottom, ${lineColor} 1px, transparent 1px)
        `,
        backgroundSize: '44px 44px',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
      }}
    />
  );
};

export default SimpleGridBackground;
